//整个应用的根组件

<template>
<div id="app">
      <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {
      isLogin: false,
      userInfo: { //保存用户信息
        nick: '',
        authorizedToken:'',
      }
    }
  },
  mounted(){
    //组件开始挂载时获取用户信息
    //this.getUserInfo();
  },

  methods: {
    
  }
}
</script>

<style>





</style>



// WEBPACK FOOTER //
// src/components/App.vue